import { useState, useCallback } from 'react';
import type { Area, MediaSize, Point } from 'react-easy-crop';
import type { CropWired } from './crop-modal-parts';

const FRAME_ASPECT = 9 / 16;

export type CropState = CropWired & { pixels: Area | null };

function computeMinZoom(s: MediaSize): number {
  const ia = s.naturalWidth / s.naturalHeight;
  return Math.max(ia / FRAME_ASPECT, FRAME_ASPECT / ia);
}

export function useCropState(): CropState {
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [minZoom, setMinZoom] = useState(1);
  const [pixels, setPixels] = useState<Area | null>(null);
  const onCropComplete = useCallback((_: Area, px: Area) => setPixels(px), []);
  const onMediaLoaded = useCallback((size: MediaSize) => {
    const z = computeMinZoom(size);
    setMinZoom(z);
    setZoom(z);
  }, []);
  return {
    crop,
    zoom,
    minZoom,
    setCrop,
    setZoom,
    onCropComplete,
    onMediaLoaded,
    pixels,
  };
}
